var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { staticClass: "bg-heart", attrs: { md: "12", lg: "12" } }, [
        _c(
          "p",
          [
            _c(
              "base-button",
              {
                staticClass: "ml-4 btn1",
                attrs: { white: "", shadow: "" },
                on: {
                  click: function($event) {
                    return _vm.getOpensaludpass()
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(_vm.button_text) + "\n        ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          [
            _c(
              "base-button",
              { attrs: { blue: "", href: "/" } },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("bgheart.more-info-btn")))]),
                _vm._v(" "),
                _c("base-icon", {
                  staticClass: "ml-2",
                  attrs: {
                    src:
                      "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                    color: "white"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-447ca5c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-447ca5c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/BgHeartButtonsDiscount.vue
// module id = 4232
// module chunks = 42